// assetInspectorHost — how a content-browser asset selection reaches the
// shell's right-hand Inspector panel.
//
// The DCC rule (Unreal/Unity): ONE details panel, fed by whatever was selected
// last — an outliner node or a content-browser asset. The ContentBrowser used
// to render its own inspector column inside the dock, which put two "details"
// surfaces on screen and left the real Inspector saying "nothing selected"
// while an asset was plainly selected.
//
// Mechanics: the shell InspectorPanel registers a HOST ELEMENT; the
// ContentBrowser portals its <Inspector> into it (createPortal), so the asset
// inspector's editing machinery — material editor, texture quality, env pose,
// all of it — stays owned by the ContentBrowser and only its DOM moves. This
// store is the rendezvous: the target element, the active flag, and the
// mutual-exclusion handshake with the outliner selection.

let _targetEl = null
let _active = false
let _clearFns = new Set()
const listeners = new Set()

function notify() {
  for (const fn of listeners) fn()
}

export const assetInspectorHost = {
  /** InspectorPanel registers its portal target here (null on unmount). */
  registerTarget(el) {
    _targetEl = el
    notify()
  },

  getTarget() { return _targetEl },

  /** ContentBrowser flips this with its asset selection. */
  setActive(on) {
    if (_active === !!on) return
    _active = !!on
    notify()
  },

  isActive() { return _active },

  /**
   * ContentBrowser registers how to drop its selection; the outliner calls
   * clear() when one of ITS rows is picked — one selection concept, so the
   * two sources evict each other instead of both claiming the panel.
   */
  registerClear(fn) {
    _clearFns.add(fn)
    return () => _clearFns.delete(fn)
  },

  clear() {
    for (const fn of _clearFns) fn()
  },

  subscribe(fn) {
    listeners.add(fn)
    fn()
    return () => listeners.delete(fn)
  },

  /** Test seam. */
  _reset() {
    _targetEl = null
    _active = false
    _clearFns = new Set()
    listeners.clear()
  },
}

export default assetInspectorHost
